export type LanguageVariation = {
    title: string;
    value: string;
};

export enum AVAILABLE_WORLDS {
    BG = 'bg', // Bulgarian
    CN = 'cn', // Chinese
    CZ = 'cz', // Czech
    DE = 'de', // German
    DK = 'dk', // Danish
    ES = 'es', // Spanish
    FI = 'fi', // Finnish
    FR = 'fr', // French
    GR = 'gr', // Greek
    HI = 'hi', // Hindi
    HR = 'hr', // Croatian
    HU = 'hu', // Hungarian
    ID = 'id', // Indonesian
    IT = 'it', // Italian
    JP = 'jp', // Japanese
    KR = 'kr', // Korean
    KZ = 'kz', // Kazakh
    MY = 'my', // Malay
    NL = 'nl', // Dutch
    NO = 'no', // Norwegian
    PL = 'pl', // Polish
    RO = 'ro', // Romanian
    RS = 'rs', // Serbian
    SE = 'se', // Swedish
    SK = 'sk', // Slovak
    TH = 'th', // Thai
    UA = 'ua' // Ukrainian
}

export const WORLD_GROUPS = {
    MAIN: [
        AVAILABLE_WORLDS.DE,
        AVAILABLE_WORLDS.ES,
        AVAILABLE_WORLDS.FR,
        AVAILABLE_WORLDS.GR,
        AVAILABLE_WORLDS.IT
    ] as string[],
    SUPPLEMENTARY: [] as string[]
};

WORLD_GROUPS.SUPPLEMENTARY = Object.values(AVAILABLE_WORLDS).filter((item: AVAILABLE_WORLDS) => {
    const isMainWorld = WORLD_GROUPS.MAIN.includes(item);

    return !isMainWorld;
});

export const FALLBACK_WORLD = AVAILABLE_WORLDS.DE;
export const languageVariations: { [key: string]: LanguageVariation[] } = {
    es: [
        {
            title: 'Español',
            value: 'es'
        },
        {
            title: 'Català',
            value: 'ca'
        },
        {
            title: 'Euskara',
            value: 'eu'
        },
        {
            title: 'Galego',
            value: 'gl'
        },
        {
            title: 'Sin texto',
            value: ''
        }
    ]
};

const DIFFERENT_COUNTRY_LANGUAGE_CODES = {
    [AVAILABLE_WORLDS.CN]: 'zh',
    [AVAILABLE_WORLDS.DK]: 'da',
    [AVAILABLE_WORLDS.CZ]: 'cs',
    [AVAILABLE_WORLDS.GR]: 'el',
    [AVAILABLE_WORLDS.JP]: 'ja',
    [AVAILABLE_WORLDS.KR]: 'ko',
    [AVAILABLE_WORLDS.KZ]: 'kk',
    [AVAILABLE_WORLDS.MY]: 'ml',
    [AVAILABLE_WORLDS.RS]: 'sr',
    [AVAILABLE_WORLDS.SE]: 'sv',
    [AVAILABLE_WORLDS.UA]: 'uk'
};

export const WORLD_LANGUAGE_CODES = {
    ...Object.values(AVAILABLE_WORLDS)
        .filter((world) => !Object.keys(DIFFERENT_COUNTRY_LANGUAGE_CODES).includes(world))
        .reduce((acc, world) => ({ ...acc, [world]: world }), {}),
    ...DIFFERENT_COUNTRY_LANGUAGE_CODES
};
